import { esCount } from '@/lib/es-count';

export function catalogSyncFinishedText(input: {
    dryRun: boolean;
    runId: number;
    status: string;
    productsUpserted: number;
    productsDeactivated: number;
    errorMessage: string | null;
    pendingBrands: number;
}): { type: 'ok' | 'err'; text: string } {
    if (input.status !== 'ok') {
        return {
            type: 'err',
            text: input.errorMessage || `La ejecución #${input.runId} ha fallado`,
        };
    }
    const pendingNote = input.pendingBrands > 0
        ? ` · ${esCount(input.pendingBrands, 'marca por asignar', 'marcas por asignar')}`
        : '';
    if (input.dryRun) {
        return {
            type: 'ok',
            text: `Previsualización · se actualizarían ${input.productsUpserted} · se desactivarían ${input.productsDeactivated}${pendingNote}`,
        };
    }
    return {
        type: 'ok',
        text: `Sincronización hecha · upsert ${input.productsUpserted} · ejecución #${input.runId}${pendingNote}`,
    };
}

/** Cifras de «Últimas ejecuciones». Una previsualización no se lee como una escritura. */
export function catalogSyncRunFiguresText(
    dryRun: boolean | null | undefined,
    counts: { upsert: string; off: string; skip: string },
): string {
    if (dryRun === true) {
        return `se actualizarían ${counts.upsert} · se desactivarían ${counts.off} · se omitirían ${counts.skip}`;
    }
    return `upsert ${counts.upsert} · off ${counts.off} · skip ${counts.skip}`;
}

/** Etiqueta de «Últimas ejecuciones». Sin dato (API antigua) no inventa el tipo. */
export function catalogSyncRunKindLabel(dryRun: boolean | null | undefined): string | null {
    if (dryRun === true) return 'Previsualización';
    if (dryRun === false) return 'Sincronización';
    return null;
}

export function pendingBrandCount(stats: Record<string, unknown> | null | undefined): number {
    const anomalies = stats && Array.isArray(stats.anomalies) ? stats.anomalies : [];
    return anomalies.filter((row) => (
        !!row && typeof row === 'object' && (row as { reason?: string }).reason === 'marca_por_asignar'
    )).length;
}
